"use client";

import { useTheme } from "next-themes";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";
import { tw } from "~/utilities/styles";

export function Toaster() {
  const { resolvedTheme } = useTheme();

  return (
    <SonnerToaster
      theme={resolvedTheme as ToasterProps["theme"]}
      closeButton
      richColors
      toastOptions={{
        classNames: {
          closeButton: tw`top-0! right-0! left-auto! translate-x-[65%]! -translate-y-[35%]!`,
        },
      }}
    />
  );
}
